import { CommonModule } from '@angular/common';
import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  EventEmitter,
  Input,
  OnChanges,
  Output,
  SimpleChanges,
} from '@angular/core';
import { FormBuilder, FormGroup, ReactiveFormsModule, Validators } from '@angular/forms';
import { TranslateModule } from '@ngx-translate/core';
import { ButtonModule } from 'primeng/button';
import { CardModule } from 'primeng/card';
import { CheckboxModule } from 'primeng/checkbox';
import { InputTextModule } from 'primeng/inputtext';
import { InputTextareaModule } from 'primeng/inputtextarea';
import { TooltipModule } from 'primeng/tooltip';
import { WorkflowSettingUpdateInfo } from '../../models';

@Component({
  selector: 'selfai-platform-workflow-settings-metadata',
  imports: [
    CommonModule,
    CardModule,
    ReactiveFormsModule,
    CardModule,
    InputTextModule,
    InputTextareaModule,
    CheckboxModule,
    ButtonModule,
    TooltipModule,
    TranslateModule,
  ],
  templateUrl: './workflow-settings-metadata.component.html',
  styleUrl: './workflow-settings-metadata.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class WorkflowSettingsMetadataComponent implements OnChanges {
  @Input() workflow!: any;
  @Output() submitEvent = new EventEmitter();

  form: FormGroup = this.fb.group({
    name: [{ value: '' }, [Validators.required]],
    description: [{ value: '' }, []],
    isPublic: [{ value: false }],
  });
  workflowData: WorkflowSettingUpdateInfo;

  constructor(
    private fb: FormBuilder,
    private changeDetectorRef: ChangeDetectorRef,
  ) {}

  ngOnChanges(changes: SimpleChanges): void {
    if (changes?.['workflow']?.currentValue) {
      this.workflowData = this.workflow.workflow;
      this.form.patchValue({
        name: this.workflowData.name,
        description: this.workflowData.description,
        isPublic: this.workflowData.isPublic,
      });
    }
  }

  onSubmit(): void {
    if (this.form.valid) {
      this.workflowData.name = this.form.value.name;
      this.workflowData.description = this.form.value.description;
      this.workflowData.isPublic = this.form.value.isPublic;
      this.submitEvent.emit(this.workflowData);
    }
  }
}
